<template>
	<v-dialog
		v-model="dialog"
		fullscreen
		persistent
		@keydown.esc="onCancel"
		@keydown.ctrl.l="log=!log"
	>
		<!-- Актіватор -->
		<template v-slot:activator="{ props: activatorProps }">
			<slot name="activator" :props="activatorProps">
			</slot>
		</template>

		<template v-slot:default="{ isActive }">
			<v-card>
				<v-toolbar prominent>
					<v-app-bar-nav-icon>
						<!-- <v-icon @click="cover=!cover" :icon="cover?'mdi-panorama-variant':'mdi-image'"></v-icon> -->
					</v-app-bar-nav-icon>
					<v-spacer></v-spacer>
					<!-- <v-btn v-if="selected != null" icon="mdi-delete-outline" @click="onDelete"></v-btn> -->
					<v-btn icon="mdi-delete-outline" @click="onDelete"></v-btn>
					<v-spacer></v-spacer>
					<!-- <v-btn icon="mdi-information-slab-circle" @click="onExif"></v-btn> -->
					<v-btn v-if="log" icon="mdi-math-log" @click="onLog" ></v-btn>
					<v-btn icon="mdi-close" @click="onClose"></v-btn>
				</v-toolbar>

				<v-progress-linear
					v-if="loading"
					color="indigo"
					:height="1"
					indeterminate
				></v-progress-linear>

				<v-navigation-drawer
					v-model="drawer"
					temporary
					absolute
					location="right"
				>
					<v-divider></v-divider>

					<v-list>
						<v-list-item v-for="(value, name) in exif" :key="name">
							<v-list-item-title>{{ name }}</v-list-item-title>

							<v-list-item-subtitle class="mb-1 text-high-emphasis opacity-100">{{ name }}</v-list-item-subtitle>

							<template v-slot:append="{ isSelected }">
								<v-list-item-action class="flex-column align-end">
									<small class="mb-4 text-high-emphasis opacity-60">{{ value }}</small>

									<v-spacer></v-spacer>

									<!-- <v-icon v-if="isSelected" color="yellow-darken-3">mdi-star</v-icon>

									<v-icon v-else class="opacity-30">mdi-star-outline</v-icon> -->
								</v-list-item-action>
							</template>
						</v-list-item>
					</v-list>
				</v-navigation-drawer>
				
				<v-card-text>
					<v-carousel 
						v-model="selected"
						hide-delimiters
						show-arrows="hover"
						cover
					>
						<v-carousel-item v-for="(item, i) in items" :key="i" :id="`img${i}`"
							:src="item.url"
						></v-carousel-item>
					</v-carousel>
				</v-card-text>
				<v-card-actions class="justify-center">
					<!-- <v-spacer></v-spacer>
					<v-btn
						class="text-none"
						color="medium-emphasis"
						variant="outlined"
						rounded
						@click="onOK"
					>OK</v-btn> -->
					<v-slide-group 
						v-model="selected"
						show-arrows
					>
						<v-slide-group-item v-for="(item, i) in items" :key="i" 
							v-slot="{ isSelected, toggle, selectedClass }"
						>
							<v-card
								:color="isSelected ? 'primary' : 'grey-lighten-1'"
								class="ma-2"
								height="64"
								width="64"
								@click="toggle"
								:elevation="isSelected?8:0"
							>
								<v-img 
									:src="item.url"
									:aspect-ratio="1"
									cover
								>
									<div class="d-flex fill-height align-end justify-end" v-if="isSelected">
										<v-scale-transition>
											<v-icon
												color="white"
												icon="mdi-check"
												size="24"
											></v-icon>
										</v-scale-transition>
									</div>
								</v-img>
							</v-card>
						</v-slide-group-item>
					</v-slide-group>
				</v-card-actions>
			</v-card>
		</template>
	</v-dialog>
</template>

<script>
import EXIF from 'exif-js'

export default {
	name: 'ImageFullscreen',
	components: {
		//Camera,
	},

	data: () => ({
		dialog: false,
		log: false,
		cover: true,
		selected: null,

		exif: {},

		drawer: false,
	}),
	props: {
		items: 				{ type: Array, default: () => []},
		multiple:   		{ type: Boolean, default: false },
		loading: 			{ type: Boolean, default: true},
	},

	watch: {
		/* dialog: function (val) {
			console.log('camera.vue', 'dialog','val', val)
			if(val) {
				//console.log('image.vue', 'dialog','items', this.items)
				this.selected = this.items.findIndex((element) => element.url==this.src)
			}
		}, */

		/* selected: function (val) {
			console.log('camera.vue', 'selected','val', val)
		}, */
	},

	methods: {
		onLog() {
			console.log('image.vue', 'onLog','items', this.items)
		},

		onClear() {
			this.selected = null
		},

		onOpen(selected) {
			this.selected = selected
			this.dialog = true
		},

		onClose () {
			console.log('image.vue', 'onClose')

			this.dialog = false
			this.onClear()
		},

		onCancel () {
			this.onClose()
		},

		onOK () {
			//console.log('image.vue', 'onOK','selected', this.selected)

			this.onClose()
		},

		onDelete() {
			//console.log('image.vue', 'onDelete','selected', this.selected)

			let selectedMin = null, selectedLen = null;
			
			if(Array.isArray(this.selected)) {
				let elements = this.selected.map((element) => this.items[element])
				elements.forEach((element) => {
					this.$emit('remove', element)
				})

				selectedMin = Math.min(...this.selected)
				selectedLen = this.selected.length
			} else {
				let element = this.items[this.selected]
				this.$emit('remove', element)

				selectedMin = this.selected
				selectedLen = 1
			}

			if(selectedMin > 0) {
				this.selected = selectedMin - 1
			}

			if(selectedLen == this.items.length) {
				this.onClose()
			}

			//console.log('image.vue', 'onDelete','selected', this.selected)
			//console.log('image.vue', 'onDelete','items.length', this.items.length)
		},

		/**
		 * EXIF meta data from image files
		 * https://github.com/exif-js/exif-js
		 * https://www.npmjs.com/package/exif-js
		 */
		async onExif() {
			//console.log(this.$options.name, 'onExif', 'selected', this.selected)

			this.drawer = !this.drawer

			var that = this

			let item = this.items[this.selected];

			//console.log(this.$options.name, 'onExif', 'item', item)
			//console.log(this.$options.name, 'onExif', 'url', item.url)

			let file = await fetch(item.url).then(r => r.blob()).then(blobFile => new File([blobFile], "fileNameGoesHere", { type: "image/jpeg" }))

			//console.log(that.$options.name, 'onExif', 'file', file)

			EXIF.getData(file, function() {
				//console.log(this.$options.name, 'onExif', 'file', file)

				that.exif = EXIF.getAllTags(this);

				console.log(that.exif)
			});
		},
	},
}
</script>